import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import Button from '../../components/ui/Button';
import { formatApiError } from '../../utils/errors';

/**
 * Error branch for a failed query. Deliberately distinct from every empty
 * state: a server outage must never read like "no results".
 */
export default function PageError({
  title = 'We could not load this',
  error,
  message,
  onRetry,
  retryLabel = 'Retry',
  className,
  children,
}) {
  return (
    <div
      role="alert"
      className={clsx('surface-panel p-6 flex flex-col items-center text-center', className)}
      data-testid="page-error"
    >
      <div className="h-12 w-12 rounded-2xl bg-danger-50 border border-danger-100 flex items-center justify-center mb-3">
        <ExclamationTriangleIcon className="h-6 w-6 text-danger-700" />
      </div>
      <h3 className="text-base font-semibold text-slate-900">{title}</h3>
      <p className="mt-1 text-sm text-slate-600 max-w-md">{message || formatApiError(error)}</p>
      {children && <div className="mt-3">{children}</div>}
      {onRetry && (
        <Button variant="secondary" className="mt-4" onClick={() => onRetry()}>
          {retryLabel}
        </Button>
      )}
    </div>
  );
}
